import { OpenPanel } from '@openpanel/web';
import {
  isProductionWebAnalyticsRuntime,
  isViteEnvTrue,
  OPENPANEL_EVENTS,
  type OpenPanelSite,
} from '@genie/shared/client';

const SITE: OpenPanelSite = 'marketplace';

let op: OpenPanel | null = null;
let warnedMissingClientId = false;

function isDevAnalyticsEnabled(): boolean {
  return isViteEnvTrue(import.meta.env.VITE_OPENPANEL_ENABLE_DEV);
}

function warnIfProductionBuildMissingClientId(): void {
  if (warnedMissingClientId) return;
  const clientId = import.meta.env.VITE_OPENPANEL_CLIENT_ID?.trim();
  if (!import.meta.env.PROD || clientId) return;
  warnedMissingClientId = true;
  console.error(
    '[OpenPanel] VITE_OPENPANEL_CLIENT_ID is missing in this production build. ' +
      'Set it in fly/marketplace-client.toml [build.args] and redeploy marketplace-client.',
  );
}

function isEnabled(): boolean {
  const clientId = import.meta.env.VITE_OPENPANEL_CLIENT_ID?.trim();
  if (!clientId) return false;

  if (isProductionWebAnalyticsRuntime(import.meta.env.PROD)) return true;

  return isDevAnalyticsEnabled();
}

export function initOpenPanel(): void {
  warnIfProductionBuildMissingClientId();
  if (op || !isEnabled()) return;

  const clientId = import.meta.env.VITE_OPENPANEL_CLIENT_ID!.trim();

  op = new OpenPanel({
    clientId,
    trackScreenViews: false,
    trackOutgoingLinks: true,
    sessionReplay: {
      enabled: true,
      maskAllInputs: true,
      maskAllText: true,
    },
  });

  op.setGlobalProperties({
    site: SITE,
    app: 'marketplace-client',
  });
}

export function trackOpenPanelScreenView(pathname: string, search: string): void {
  if (!op) return;

  op.screenView(`${pathname}${search}`, {
    site: SITE,
    path: pathname,
    search: search || undefined,
  });
}

export function trackOpenPanelEvent(
  eventName: string,
  properties?: Record<string, unknown>,
): void {
  if (!op) return;

  op.track(eventName, {
    site: SITE,
    ...properties,
  });
}

export { OPENPANEL_EVENTS };
